export default __webpack_public_path__ + "static/media/outcess17.37ae2886.jpeg";